export class MediumTypeModel {

    MediumType = '';
    MediumName = '';
    MediumTypeName = '';
    BundleCatalogFlag = '';
    DutiesFormDiv = '0';
    MediumGroupDiv = '';
}